import axios from 'axios'
import { memberCalls2Url } from '@helpers'

const getDictionary = ({ web, countryCode }: { web: string; countryCode: string }) => {
    const url = memberCalls2Url({
        path: `/hot/dictionary/v2/publish/${countryCode}/${web}`,
        env: 'live'
    })

    return axios.get(url)
}

export const dictionaryApi = {
    getDictionary
}
